if (!customElements.get("el-results-breakdown")) {
  class ElResultsBreakdown extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.hasAnimated = false;
    }

    connectedCallback() {
      if (this.dataset.ready === "true") return;

      this.dataset.ready = "true";

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.showFinalValues();
        return;
      }

      const target =
        this.closest(".el-results-breakdown") ||
        this.closest(".shopify-section") ||
        this;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || this.hasAnimated) return;

            this.hasAnimated = true;
            this.playAnimation();
            this.observer.disconnect();
          });
        },
        {
          threshold: 0.15,
          rootMargin: "0px 0px -12% 0px",
        },
      );

      this.observer.observe(target);
    }

    playAnimation() {
      this.classList.remove("is-visible");

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.add("is-visible");
          this.animateStats();
        });
      });
    }

    animateStats() {
      const stats = this.querySelectorAll("[data-stat]");

      stats.forEach((stat, index) => {
        const number = stat.querySelector("[data-stat-number]");
        const target = Number(stat.dataset.statValue) || 0;
        const delay = index * 120;

        if (!number) return;

        window.setTimeout(() => {
          this.animateNumber(number, target);
        }, delay);
      });
    }

    animateNumber(element, target) {
      const duration = 1000;
      const startTime = performance.now();

      const update = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 4);
        const value = Math.round(target * eased);

        element.textContent = `${value}%`;

        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          element.textContent = `${target}%`;
        }
      };

      requestAnimationFrame(update);
    }

    showFinalValues() {
      this.classList.add("is-visible");

      this.querySelectorAll("[data-stat]").forEach((stat) => {
        const number = stat.querySelector("[data-stat-number]");
        const target = Number(stat.dataset.statValue) || 0;

        if (number) {
          number.textContent = `${target}%`;
        }
      });
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      this.dataset.ready = "false";
    }
  }

  customElements.define("el-results-breakdown", ElResultsBreakdown);
}
